import { createContext, useContext, useState } from "react"
import { PropTypes } from "prop-types"
import _ from "lodash"

export const AccordionContext = createContext({
  openSections: {},
  isPrintable: false,
  onClick: _.noop,
  handleKeyDown: _.noop,
  refs: []
})

export function AccordionProvider({
  children,
  refs,
  allowMultipleOpen = false,
  isPrintable = false,
  openFirstByDefault = false,
  handleKeyDown = _.noop
}) {
  const [openSections, setOpenSections] = useState({ 0: openFirstByDefault })
  const handleClick = index => {
    if (allowMultipleOpen) {
      setOpenSections(previousOpenSections => ({
        ...previousOpenSections,
        [index]: !openSections[index]
      }))
    } else {
      setOpenSections({ [index]: !openSections[index] })
    }
  }

  return (
    <AccordionContext.Provider
      value={{
        openSections,
        isPrintable,
        handleClick,
        handleKeyDown,
        refs
      }}
    >
      {children}
    </AccordionContext.Provider>
  )
}

export function useAccordionContext(index) {
  const { openSections, isPrintable, handleClick, handleKeyDown, refs } =
    useContext(AccordionContext)

  return {
    isOpen: Boolean(openSections[index]),
    isPrintable,
    onClick: () => handleClick(index),
    onKeyDown: handleKeyDown(index),
    ref: refs?.current[index]
  }
}

AccordionProvider.propTypes = {
  allowMultipleOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
  isPrintable: PropTypes.bool,
  openFirstByDefault: PropTypes.bool,
  handleKeyDown: PropTypes.func,
  refs: PropTypes.shape({
    current: PropTypes.arrayOf(PropTypes.object)
  })
}
